/**
 * Função para tratar a apresentação de modal de conteúdo informando os dados relacionados ao tipo de variação do preço
 */
const modalInfoVariations = () => {
  const $modal = $('#qty-modal');
  const $body = $('body');
  const $overlay = $('.overlay-footer');
  const closeModal = () => {
    $body.removeClass('qty-modal-active');
  };
  const openModal = () => {
    $body.addClass('qty-modal-active');
  };

  $modal.find('.qty-modal-close').on('click', (event) => {
    event.preventDefault();
    closeModal();
  });

  $overlay.on('click', () => {
    closeModal();
  });

  $(document).on('click.customInfoVariationsSku', '.shelf .rnk-card-descricao .unity', (event) => {
    const $unity = $(event.currentTarget);
    const $size = $unity.siblings('.size-unity').find('li');
    if ($size.is(':visible')) {
      return false;
    }
    const typeVariation = $unity.find('li:eq(0)').attr('class');

    let title = '';
    let phrase = '';
    switch (typeVariation) {
      case 'embalagem':
        title = '';
        if ($size.length) {
          phrase = `Embalagem de ${$size.text()}`;
        }
        break;
      case 'unidade':
        title = 'Quantidade';
        if ($size.length) {
          phrase = `Contém ${$size.text()}`;
        }
        break;
      case 'combo':
        title = 'COMBO';
        if ($size.length) {
          phrase = `${$size.text()}`;
        }
        break;
      case 'kit':
        title = 'KIT';
        if ($size.length) {
          phrase = `Mix de produtos`;
        }
        break;
      case 'por-kg':
      case 'kg':
        title = 'Peso Variável';
        phrase =
          'O preço final pode variar de acordo com o peso medido durante a preparação do seu pedido. Saiba mais em nosso FAQ.';
        break;
      default:
        break;
    }

    if (title) {
      $modal.find('.qty-modal-title').html(title);
      $modal.find('.qty-modal-text').html(phrase);
      openModal();
    }
  });
};

modalInfoVariations();

export {};
